import { render, staticRenderFns } from "./QuizQuestion.vue?vue&type=template&id=13704c00&"
import script from "./QuizQuestion.vue?vue&type=script&lang=js&"
export * from "./QuizQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuizQuestion.vue?vue&type=style&index=0&id=13704c00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports